// src/components/AdminSettings/tabs/PhotosTab.tsx
import React from 'react';
import { add, trash, imagesOutline } from 'ionicons/icons';
import { Button } from '../../ui/Button';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { List, type ListItemProps } from '../../ui/List';
import type { PhotosTabProps } from '../types';

export const PhotosTab: React.FC<PhotosTabProps> = ({
  albums,
  onAddAlbum,
  onEditAlbum,
  onDeleteAlbum,
}) => {
  // Convert albums to List items
  const albumItems: ListItemProps[] = albums.map(album => ({
    id: album.id,
    label: album.name,
    start: { icon: imagesOutline },
    end: {
      element: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Badge variant="neutral" size="sm">
            {album.photo_count} {album.photo_count === 1 ? 'photo' : 'photos'}
          </Badge>
          <Button
            fill="clear"
            size="small"
            iconStart={trash}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteAlbum(album.id);
            }}
            aria-label="Delete album"
            style={{ color: 'var(--ion-color-danger)' }}
          />
        </div>
      ),
    },
    onClick: () => onEditAlbum(album),
  }));

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}>
        <h3 style={{
          fontFamily: 'var(--kff-heading-font)',
          fontSize: 16,
          fontWeight: 600,
          margin: 0,
        }}>
          Photo Albums
        </h3>
        <Button variant="primary" size="small" iconStart={add} onClick={onAddAlbum}>
          Add Album
        </Button>
      </div>

      <p style={{
        fontSize: 13,
        color: 'var(--ion-color-medium)',
        marginBottom: 16,
      }}>
        Create photo albums for the dashboard slideshow and screensaver.
      </p>

      {albumItems.length > 0 ? (
        <List items={albumItems} variant="default" size="md" lines="inset" />
      ) : (
        <Card style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--ion-color-medium)', marginBottom: 16 }}>
            No photo albums created yet
          </p>
          <Button variant="primary" onClick={onAddAlbum}>
            Create First Album
          </Button>
        </Card>
      )}
    </>
  );
};

export default PhotosTab;
